import { publishReplay, refCount } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { SelfScanConfDetail, SelfScanConfDetailRow } from '../../models/loyalty-selfScan.model';
import { ListMetadata } from '../../models/list-metadata.model';
import { Observable } from 'rxjs/Observable';
import {LayoutDetail} from '../../models/loyalty-layout.model';

@Injectable()
export class LoyaltySelfscanconfdetailService {

  public baseUrl = '/koncentro-loyalty';
  private cachedFields: Observable<any>;

  constructor(
    private http: HttpClientService
  ) { }

  get(selfscanId, selfscanDetailId): Observable <SelfScanConfDetail> {
    return this.http.get(this.baseUrl + '/self_scanning/' + selfscanId + '/detail/' + selfscanDetailId);
  }

  list(selfscanId): Observable <{data: Array<SelfScanConfDetail>, metadata: ListMetadata }> {
    return this.http.getPaged(this.baseUrl + '/self_scanning/' +  selfscanId + '/detail/');
  }

  update(selfscanId, selfscanDetailId, selfScanConfDetail: SelfScanConfDetail): Observable<SelfScanConfDetail> {
    return this.http.put(this.baseUrl + '/self_scanning/' + selfscanId + '/detail/' + selfscanDetailId, selfScanConfDetail);
  }

  create(selfscanId, selfscanDetail: SelfScanConfDetail): Observable<SelfScanConfDetail> {
    let detailRow = new SelfScanConfDetailRow();
    detailRow.id = selfscanDetail.id;
    detailRow.max = selfscanDetail.max;
    detailRow.min = selfscanDetail.min;
    detailRow.self_scanning_rules_id = selfscanDetail.self_scanning_rules_id;
    detailRow.step = selfscanDetail.step;
    return this.http.post(this.baseUrl + '/self_scanning/' + selfscanId + '/detail/', detailRow);
  }

  remove(selfscanId, selfscanDetailId): Observable<SelfScanConfDetail> {
    return this.http.delete(this.baseUrl + '/self_scanning/' + selfscanId + '/detail/' + selfscanDetailId);
  }

  getFields () {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/SelfScanningRuleDetailDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }


}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-selfscanconfdetail.service.ts